import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgMapPinAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.999,
    viewBox: "0 0 18 19.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.899v5.1a1 1 0 002 0v-5.1a5 5 0 10-2 0zm1-7.9a3 3 0 11-3 3 3 3 0 013-3zm4.21 10.42a1.022 1.022 0 00-.42 2c2.27.45 3.21 1.26 3.21 1.58 0 .58-2.45 2-7 2s-7-1.42-7-2c0-.32.94-1.13 3.21-1.62a1.022 1.022 0 10-.42-2c-3.04.7-4.79 2.01-4.79 3.62 0 2.63 4.53 4 9 4s9-1.37 9-4c0-1.61-1.75-2.92-4.79-3.58z",
    fill: "#fff"
  })));
}

export { SvgMapPinAlt as ReactComponent };
//# sourceMappingURL=MapPinAlt.svg.js.map
